export const initialPurchaseState = {
    vendor: null,
    products: [],
    purchaseOrders: [],
    purchase: [],
    productLists :[],
    discount: 0,
    tax: 0,
    selectedProduct: '',
    quantity: 1,
  };
  